export const ANIM_DURATION = 600;
export const STEPS = 10;
export const MIN_WINDOW_WIDTH = 790;
export const MIN_WINDOW_HEIGHT = 528;
export const PARKING_LEFT = 60;
export const THRESHOLD = 60;
export const MAX_PHOTOS_PER_LINE = 2;
export const ANIMATIONS = {
	SHOW_START: 100,
	SHOW_END: 1000,
	HIDE: 1000,
};
export const ITEM_GAP = 8;
// 550
export const PHOTOS_MAX_WIDTH = Math.floor(550 * 2 / 3);
export const PHOTOS_MULTI_LINE_HEIGHT = 94; //122
export const WIDTH_NEWS = 174;
export const WIDTH_PHOTO = 174;
export const WIDTH_POI = 299;
export const WIDTH_REVIEW = 174;
export const PHOTO_SIZE = ["500", "500"];
//export const PHOTO_SIZE = ["400", "225"];
export const LIMITS = {
	NEWS: 2,
	PHOTOS_MATRIX: 4,
	LOAD_REVIEWS: 100,
	REVIEWS: 2,
	POIS: 3,
	MIN_CONTENTS: 2,
};
export const MIN_VISIBLE_PX = 25;
// pro testy
export const RIBBON_HEIGHT = 277;
export const MAX_HEIGHT_PERC = 49;
// roboti - pov/zap manualne
export const ENABLE_RIBBON_ROBOTS = false;
